module.exports = __webpack_public_path__ + "img/middle_17.ebc9f195.png";